import $x from '@/utils/$x';

/**
 * 查询渠道列表
 * @param {*} params
 * @returns
 */
export async function getChannelList(params) {
  return $x.post('/v1/litta/channel/list', params);
}

/**
 * 新建渠道
 * @param {*} params
 * @returns
 */
export async function createChannel(params) {
  return $x.post('/v1/litta/channel/add', params);
}

/**
 * 更新渠道
 * @param {*} params
 * @returns
 */
export async function updateChannel(params) {
  return $x.post('/v1/litta/channel/update', params);
}

/**
 * 删除渠道
 * @param {*} params
 * @returns
 */
export async function deleteChannel(params) {
  return $x.post('/v1/litta/channel/delete', params);
}

/// ### 推广渠道 ###
/**
 * 查询推广渠道列表
 * @param {*} params
 * @returns
 */
export async function getPromotionChannelList(params) {
  return $x.post('/v1/litta/channel/pageList', params);
}

/**
 * 新建推广渠道列表
 * @param {*} params
 * @returns
 */
export async function addPromotionChannel(params) {
  return $x.post('/v1/litta/channel/addPromotionChannel', params);
}

/**
 * 删除推广渠道列表
 * @param {*} params
 * @returns
 */
export async function deletePromotionChannel(params) {
  return $x.post('/v1/litta/channel/deletePromotionChannel', params);
}

/**
 * 修改推广渠道列表
 * @param {*} params
 * @returns
 */
export async function updatePromotionChannel(params) {
  return $x.post('/v1/litta/channel/updatePromotionChannel', params);
}

/**
 * 修改推广渠道列表
 * @param {*} params
 * @returns
 */
export async function getPromotionChannel(params) {
  return $x.post('/v1/litta/channel/getPromotionChannel', params);
}

/**
 * 渠道下拉列表
 * @param {*} params
 * @returns
 */
export async function getPromotionSelectList(params) {
  return $x.post('/v1/litta/channel/channelList', params);
}

/**
 * 推广渠道下拉列表
 * @param {*} params
 * @returns
 */
export async function getPromotionChannelSelectList(params) {
  return $x.post('/v1/litta/channel/promotionChannelList', params);
}

/// ### 推广链接 ###

/**
 * 推广链接分页查询
 * @param {*} params
 * @returns
 */
export async function getPromotionLinkList(params) {
  return $x.post('/consultation/link/pageList', params);
}

/**
 * 新增链接
 * @param {*} params
 * @returns
 */
export async function requestAddPromotionLink(params) {
  return $x.post('/consultation/link/add', params);
}

/**
 * delete链接
 * @param {*} params
 * @returns
 */
export async function requestDeletePromotionLink(params) {
  return $x.post('/consultation/link/delete', params);
}

/**
 * update链接
 * @param {*} params
 * @returns
 */
export async function requestUpdatePromotionLink(params) {
  return $x.post('/consultation/link/update', params);
}

/**
 * 广告账号列表
 * @param {*} params
 * @returns
 */
export async function requestAdvertisingAccounts(params) {
  return $x.post('/consultation/link/getAdvertisingAccounts', params);
}
/**
 * 当前链接下的线索用户列表
 * @param {*} params
 * @returns
 */
export async function queryConsultationLinkRecordList(params) {
  return $x.post('/consultation/link/queryConsultationLinkRecordList', params);
}

/// ### 留资页 ###

/**
 * 留资页分页查询
 * @param {*} params
 * @returns
 */
export async function getConsultList(params) {
  return $x.post('/consultation/page/pageList', params);
}

/**
 * 新增
 * @param {*} params
 * @returns
 */
export async function requestAddConsult(params) {
  return $x.post('/consultation/page/add', params);
}

/**
 * delete
 * @param {*} params
 * @returns
 */
export async function requestDeleteConsult(params) {
  return $x.post('/consultation/page/delete', params);
}

/**
 * update
 * @param {*} params
 * @returns
 */
export async function requestUpdateConsult(params) {
  return $x.post('/consultation/page/update', params);
}

/**
 * 详情
 * @param {*} params
 * @returns
 */
export async function requestConsultDetail(params) {
  return $x.post('/consultation/page/get', params);
}

/**
 * 留咨页名称列表-查
 * @param {*} params
 * @returns
 */
export async function requestConsultNameList(params) {
  return $x.post('/consultation/page/nameList', params);
}

/**
 *  平台 列表
 * @param {*} params
 * @returns
 */
export async function getPlatformList(params) {
  return $x.post('/platform/queryPlatformList', params);
}

/**
 *  平台 新建
 * @param {*} params
 * @returns
 */
export async function addPlatform(params) {
  return $x.post('/platform/createPlatform', params);
}

/**
 *  平台 更新
 * @param {*} params
 * @returns
 */
export async function updatePlatform(params) {
  return $x.post('/platform/updatePlatform', params);
}

/**
 *  平台 删除
 * @param {*} params
 * @returns
 */
export async function deletePlatform(params) {
  return $x.post('/platform/deletePlatform', params);
}

/**
 *  平台 全量数据
 * @param {*} params
 * @returns
 */
export async function queryAllPlatform(params) {
  return $x.post('/platform/queryAllPlatform', params);
}

/**
 *  绑定渠道和平台
 * @param {*} params
 * @returns
 */
export async function bindPlatform(params) {
  return $x.post('/v1/litta/channel/bindPlatform', params);
}

/**
 *  显示渠道的公众号二维码
 * @param {*} params
 * @returns
 */
export async function showWxMpQr(params) {
  return $x.post('/v1/litta/channel/showWxMpQr', params);
}

/**
 *  显示渠道的公众号二维码
 * @param {*} params
 * @returns
 */
export async function getDMAppletCode(params) {
  return $x.post('/sidebar/get-dm-applet-code', params);
}

/**
 *  查询渠道下的口令信息
 * @param {*} params
 * @returns
 */
export async function queryChannelCodeRedeem(params) {
  return $x.post('/v1/litta/channel/queryChannelCodeRedeem', params);
}

/**
 *  保存口令信息
 * @param {*} params
 * @returns
 */
export async function saveChannelCodeRedeem(params) {
  return $x.post('/v1/litta/channel/saveChannelCodeRedeem', params);
}
/**
 *  更新口令信息
 * @param {*} params
 * @returns
 */
export async function updateChannelCodeRedeem(params) {
  return $x.post('/v1/litta/channel/updateChannelCodeRedeem', params);
}
/**
 *  查询计划
 * @param {*} params
 * @returns
 */
export async function listPlanForChannel(params) {
  return $x.post('/specialcourse/listPlanForChannel', params);
}
/**
 *  查询渠道详情
 * @param {*} params
 * @returns
 */
export async function getChannelDetail(params) {
  return $x.post('/v1/litta/channel/get', params);
}
/**
 *  代理商列表
 * @param {*} params
 * @returns
 */
export async function getAgentList(params) {
  return $x.post('/channel-agents/page-agents', params);
}
/**
 *  更新代理商状态
 * @param {*} params
 * @returns
 */
export async function updateAgentStatus(params) {
  return $x.post('/channel-agents/update-agents-status', params);
}
/**
 *  新增代理商
 * @param {*} params
 * @returns
 */
export async function addAgent(params) {
  return $x.post('/channel-agents/add-agents', params);
}
/**
 *  新增代理商
 * @param {*} params
 * @returns
 */
export async function updateAgent(params) {
  return $x.post('/channel-agents/update-agents', params);
}
/**
 *  代理商下挂渠道列表
 * @param {*} params
 * @returns
 */
export async function agentChannel(params) {
  return $x.post('/channel-agents/list-agents-channel', params);
}
/**
 *  代理商下挂渠道 新增
 * @param {*} params
 * @returns
 */
export async function addAgentChannel(params) {
  return $x.post('/channel-agents/add-agents-channel', params);
}
/**
 *  代理商下挂渠道 删除
 * @param {*} params
 * @returns
 */
export async function delAgentChannel(params) {
  return $x.post('/channel-agents/del-agents-channel', params);
}
/**
 *  代理商商品
 * @param {*} params
 * @returns
 */
export async function agentGoods(params) {
  return $x.post('/channel-agents/list-agents-goods-settlement', params);
}
/**
 *  代理商商品
 * @param {*} params
 * @returns
 */
export async function addAgentGoods(params) {
  return $x.post('/channel-agents/add-agents-goods-settlement', params);
}
/**
 *  代理商商品
 * @param {*} params
 * @returns
 */
export async function delAgentGoods(params) {
  return $x.post('/channel-agents/del-agents-goods-settlement', params);
}
/**
 *  代理商账户
 * @param {*} params
 * @returns
 */
export async function agentAccount(params) {
  return $x.post('/channel-agents/agents-account-detail', params);
}
/**
 *  代理商账户
 * @param {*} params
 * @returns
 */
export async function tradeAgentAccount(params) {
  return $x.post('/channel-agents/agents-account-trade', params);
}
/**
 *  更新代理商结算商品结算金额
 * @param {*} params
 * @returns
 */
export async function updateAgentAccount(params) {
  return $x.post(
    '/channel-agents/update-agents-goods-settlement_amount',
    params,
  );
}
/**
 *  查询代理商绑定的渠道列表
 * @param {*} params
 * @returns
 */
export async function getBindChannelList(params) {
  return $x.post('/agency/bind/channel/pageBind', params);
}
/**
 *  绑定
 * @param {*} params
 * @returns
 */
export async function addBindChannel(params) {
  return $x.post('/agency/bind/channel/addBind', params);
}
/**
 *  解绑
 * @param {*} params
 * @returns
 */
export async function unBindChannel(params) {
  return $x.post('/agency/bind/unbind', params);
}
/**
 *  查询代理商绑定的品牌列表
 * @param {*} params
 * @returns
 */
export async function getBindBrandList(params) {
  return $x.post('/agency/bind/brand/list', params);
}
/**
 *  品牌列表(分页)
 * @param {*} params
 * @returns
 */
export async function getBindBrandPage(params) {
  return $x.post('/agency/bind/brand/page', params);
}
/**
 *  保存或更新品牌绑定
 * @param {*} params
 * @returns
 */
/**
 * 查询商家主体信息
 * @param {*} params
 * @returns
 */
export async function getEnterpriseDetail(params) {
  return $x.post('/enterprise/getEnterprise', params);
}

/**
 * 修改商家主体信息
 * @param {*} params
 * @returns
 */
/**
 * 查询商家下挂店铺列表
 * @param {*} params
 * @returns
 */
export async function pageEnterpriseStore(params) {
  return $x.post('/enterprise/pageEnterpriseStore', params);
}

/**
 * 解绑商家下挂店铺
 * @param {*} params
 * @returns
 */
/**
 * 绑定商家下挂店铺
 * @param {*} params
 * @returns
 */
export async function enterpriseBandTenant(params) {
  return $x.post('/enterprise/enterpriseBandTenant', params);
}

export async function enterpriseDisBandTenant(params) {
  return $x.post('/enterprise/enterpriseDisBandTenant', params);
}

export async function modifyEnterpriseBaseInfo(params) {
  return $x.post('/enterprise/modifyEnterpriseBaseInfo', params);
}

export async function queryProductCapability(params) {
  return $x.post('/enterprise/productCapability', params);
}

export async function setUpBizConfig(params) {
  return $x.post('/enterprise/config/setUpBizConfig', params);
}

// 调整企业员工基础额度（num 正增负减）
// "requestData": {
//         "enterpriseId": 167,
//         "num": 103,
//     },
export async function adjustEmployeeBaseQuota(params) {
  return $x.post('/enterprise/adjustEmployeeBaseQuota', params);
}

// 调整企业店铺数量额度
// "requestData": {
//         "enterpriseId": 167,
//         "num": 103,
//     },
export async function adjustShopQuota(params) {
  return $x.post('/enterprise/adjustShopQuota', params);
}

// 企业操作日志分页
// "requestData": {
//         "enterpriseId": 167,
//         "operateType": operateType 5 员工 6店铺 7活力GO,
//     },
export async function pageEnterpriseOperateLog(params) {
  return $x.post('/enterprise/pageEnterpriseOperateLog', params);
}

// 修改活力GO分销比例
// "requestData": {
//     "enterpriseId": 167,
//     "percent": 0.05,  // 绝对值，小数如 0.05 表示 5%
// }
export async function updateVitalityGoAttributionPercent(params) {
  return $x.post('/enterprise/updateVitalityGoAttributionPercent', params);
}

export async function saveOrUpdateBrand(params) {
  return $x.post('/agency/bind/brand/saveOrUpdate', params);
}
/**
 *  设置或取消品牌绑定
 * @param {*} params
 * @returns
 */
export async function setUpAndDownBrand(params) {
  return $x.post('/agency/bind/brand/setUpAndDown', params);
}
/**
 *  品牌绑定
 * @param {*} params
 * @returns
 */
export async function pageBindList(params) {
  return $x.post('/agency/bind/brand/pageBind', params);
}
/**
 *  品牌绑定 商家
 * @param {*} params
 * @returns
 */
export async function addBindBrand(params) {
  return $x.post('/agency/bind/brand/addBind', params);
}
/**
 *  品牌绑定 商家
 * @param {*} params
 * @returns
 */
export async function getBindTenantList(params) {
  return $x.post('/agency/bind/tenant/pageBind', params);
}
/**
 *  品牌绑定 商家
 * @param {*} params
 * @returns
 */
export async function bindTenant(params) {
  return $x.post('/agency/bind/tenant/addBind', params);
}
/**
 *  品牌绑定 商家
 * @param {*} params
 * @returns
 */
export async function getChannelListForBind(params) {
  return $x.post('/agency/bind/channel/list', params);
}
/**
 *  扣款计划列表 商家
 * @param {*} params
 * @returns
 */
export async function pageDeductPlan(params) {
  return $x.post('/athena/pageDeductPlan', params);
}

/**
 *  查询关联主体
 * @param {*} params
 * @returns
 */
export async function getEnterprisePage(params) {
  return $x.post('/enterprise/page', params);
}

/**
 * 查询主体下商家列表
 * @param {*} params
 * @returns
 */
export async function getEnterpriseStoreList(params) {
  return $x.post('/enterprise/store/list', params);
}
/**
 *  商家主体管理
 * @param {*} params
 * @returns
 */
export async function pageEnterpriseManage(params) {
  return $x.post('/enterprise/pageEnterprise', params);
}
/**
 *  商家主体新增
 * @param {*} params
 * @returns
 */
export async function addEnterprise(params) {
  return $x.post('/enterprise/addEnterprise', params);
}
/**
 *  商家主体状态变更
 * @param {*} params
 * @returns
 */
export async function changeEnterpriseStatus(params) {
  return $x.post('/enterprise/changeStatus', params);
}

/**
 *  员工管理 - 分页查询主体下员工列表
 * @param {*} params
 * @returns
 */
export async function enterpriseUserPage(params) {
  return $x.post('/enterprise/enterpriseUserPage', params);
}

/**
 *  员工管理 - 新增员工（绑定手机号到主体）
 * @param {*} params
 * @returns
 */
export async function addEnterpriseUser(params) {
  return $x.post('/enterprise/addEnterpriseUser', params);
}

/**
 *  员工管理 - 解绑员工
 * @param {*} params
 * @returns
 */
export async function delEnterpriseUser(params) {
  return $x.post('/enterprise/delEnterpriseUser', params);
}

/**
 *  员工管理 - 指派店铺（绑定员工到主体下店铺）
 * @param {*} params
 * @returns
 */
export async function assignStore(params) {
  return $x.post('/enterprise/assignStore', params);
}

/**
 *  员工管理 - 修改企业成员角色
 * @param {*} params
 * @returns
 */
export async function modifyEnterpriseUserRole(params) {
  return $x.post('/enterprise/modifyEnterpriseUserRole', params);
}

/**
 * 首页配置的查询接口
 * @param {*} params
 * @returns
 */
export async function getEnterpriseMainConfig(params) {
  return $x.post('/enterprise/config/getEnterpriseMainConfig', params);
}

/**
 * 首页配置的保存接口
 * @param {*} params
 * @returns
 */
export async function enableMainConfig(params) {
  return $x.post('/enterprise/config/enableMainConfig', params);
}

/**
 * 查询品牌logo配置接口
 * @param {*} params
 * @returns
 */
export async function getBrandLogoCustomConfig(params) {
  return $x.post('/enterprise/config/getBrandLogoCustomConfig', params);
}

/**
 * 保存品牌logo配置接口
 * @param {*} params
 * @returns
 */
export async function enableBrandLogoCustomConfig(params) {
  return $x.post('/enterprise/config/enableBrandLogoCustomConfig', params);
}

/**
 *  创建店铺导入记录
 * @param {*} params
 * @returns
 */
export async function enterpriseStoreImportCreate(params) {
  return $x.post('/enterprise/store/import/create', params);
}

/**
 *  获取excel文件解析结果
 * @param {*} params
 * @returns
 */
export async function enterpriseStoreImportParseResult(params) {
  return $x.post('/enterprise/store/import/parse/result', params);
}

/**
 *  执行店铺导入
 * @param {*} params
 * @returns
 */
export async function enterpriseStoreImportExecute(params) {
  return $x.post('/enterprise/store/import/execute', params);
}

/**
 *  获取店铺导入状态
 * @param {*} params
 * @returns
 */
export async function enterpriseStoreImportStatus(params) {
  return $x.post('/enterprise/store/import/status', params);
}

/**
 *  下载错误报告
 * @param {*} params
 * @returns
 */
export async function enterpriseStoreImportErrorReport(params) {
  return $x.post('/enterprise/store/import/error/report', params);
}

/**
 *  获取店铺导入记录列表
 * @param {*} params
 * @returns
 */
export async function enterpriseStoreImportList(params) {
  return $x.post('/enterprise/store/import/list', params);
}

/**
 * 获取工单配置列表
 * @param {*} params
 * @returns
 */
export async function getPendingOrderConfig(params) {
  return $x.post('/enterprise/config/getPendingOrderConfig', params);
}

/**
 * 开启/关闭工单配置
 * @param {*} params
 * @returns
 */
export async function enablePendingOrderConfig(params) {
  return $x.post('/enterprise/config/enablePendingOrderConfig', params);
}

/**
 * 修改工单优先级
 * @param {*} params
 * @returns
 */
export async function updatePendingOrderPriority(params) {
  return $x.post('/enterprise/config/updatePendingOrderPriority', params);
}

/**
 * 获取企业商品列表
 * @param {*} params
 * @returns
 */
export async function listGoodsByEnterpriseId(params) {
  return $x.post('/enterprise/goods/listByEnterpriseId', params);
}

/**
 * 自定义待处理工单配置（新增/修改）
 * @param {*} params
 * @returns
 */
export async function customPendingOrderConfig(params) {
  return $x.post('/enterprise/config/customPendingOrderConfig', params);
}
